module.exports = __webpack_public_path__ + "static/media/location-pests.bc009eeb.png";